/** Tab ids of the thank-you page (after checkout) map settings page. */
export enum AfterCheckoutMapSettingsTabId {
    Design = 'thank-you-page-map-settings-tab',
    Translation = 'translation-tab',
}

/** Tab ids of the shipping zones and rates page. */
export enum ShippingZoneRateTabId {
    ShippingZones = 'shipping-zones-tab',
    ShippingRates = 'shipping-rates-tab',
    HomeDelivery = 'home-delivery-tab',
}

/** Tab ids of the cart / map design settings page. */
export enum DesignSettingsTabId {
    CartButtonDesign = 'cart-button-design-tab',
    CartAppExtension = 'cart-app-extension-tab',
    Translation = 'translation-tab',
}
